import { Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { fontWeights } from '@/@mui/tokens/font-weights';
import { ContentBox } from '@/components/shared/content-box';
import { KeyValue } from '@/components/shared/key-value';
import type { ResourceApprovalDetails } from '@/data/subsidy/resource-approvals/details/interfaces';
import { StatusChip } from '@/packages/subsidy/components/status-chip';
import type { DetailsProps } from '@/packages/subsidy-management/interfaces';
import { formatDate } from '@/utils/format-date';
import { formatMoney } from '@/utils/format-money';

interface RefundRequestItemProps {
  refundRequest: ResourceApprovalDetails['refund_requests'][0];
}

const RefundRequestItem = ({ refundRequest }: RefundRequestItemProps) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction={{ md: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'start', md: 'center' }}
      gap={2}
    >
      <KeyValue
        label="Data da solicitação"
        value={formatDate(refundRequest.created_at)}
        column
      />
      <KeyValue
        label="Reembolso solicitado"
        value={formatMoney(refundRequest.refundable_amount)}
        column
      />
      <Stack width={260} alignItems="start">
        <Typography fontWeight={fontWeights.fontWeightSemibold}>
          Situação
        </Typography>
        <StatusChip status={refundRequest.status} />
      </Stack>
      <Button variant="outlined" onClick={() => navigate(refundRequest.uuid)}>
        Ver detalhes
      </Button>
    </Stack>
  );
};

export const RefundRequests = ({ resourceApprovalsDetails }: DetailsProps) => {
  const refundRequests = resourceApprovalsDetails?.refund_requests || [];

  return (
    <ContentBox>
      <Typography variant="h2" mb={3} color="primary.dark">
        Histórico de reembolsos
      </Typography>
      <Stack gap={{ xs: 4, md: 2 }}>
        {refundRequests.length > 0 ? (
          refundRequests.map((request) => (
            <RefundRequestItem key={request.uuid} refundRequest={request} />
          ))
        ) : (
          <Typography>
            Este usuário ainda não solicitou reembolsos para este item.
          </Typography>
        )}
      </Stack>
    </ContentBox>
  );
};
